import React from "react";
import SuperAdminSalaries from "../superadmin/payroll/SalariesPage";

const SalariesPage = () => {
    return <SuperAdminSalaries />;
};

export default SalariesPage;
